/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { FreelancersList } from './';
import {
    FreelancersListFromJSON,
    FreelancersListFromJSONTyped,
    FreelancersListToJSON,
} from './';

/**
 * 
 * @export
 * @interface FreelancersListsResponse
 */
export interface FreelancersListsResponse {
    /**
     * 
     * @type {Array<FreelancersList>}
     * @memberof FreelancersListsResponse
     */
    lists: Array<FreelancersList>;
    /**
     * 
     * @type {number}
     * @memberof FreelancersListsResponse
     */
    totalListsCount: number;
    /**
     * Identifier of the list
     * @type {string}
     * @memberof FreelancersListsResponse
     */
    lastFavoriteListId?: string;
}

/**
 * Check if a given object implements the FreelancersListsResponse interface.
 */
export function instanceOfFreelancersListsResponse(value: object): value is FreelancersListsResponse {
    if (!('lists' in value) || value['lists'] === undefined) return false;
    if (!('totalListsCount' in value) || value['totalListsCount'] === undefined) return false;
    return true;
}

export function FreelancersListsResponseFromJSON(json: any): FreelancersListsResponse {
    return FreelancersListsResponseFromJSONTyped(json, false);
}

export function FreelancersListsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancersListsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'lists': ((json['lists'] as Array<any>).map(FreelancersListFromJSON)),
        'totalListsCount': json['totalListsCount'],
        'lastFavoriteListId': json['lastFavoriteListId'] == null ? undefined : json['lastFavoriteListId'],
    };
}

export function FreelancersListsResponseToJSON(value?: FreelancersListsResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'lists': ((value['lists'] as Array<any>).map((v) => FreelancersListToJSON(v))),
        'totalListsCount': value['totalListsCount'],
        'lastFavoriteListId': value['lastFavoriteListId'],
    };
}

